import QuoteList from '../modules/quote_table/quote_list'
import QuoteTable from '../modules/quote_table/index'
import TemplateBK from '../modules/template_html/bk'
import delayparams from '../modules/url/delayQuote';
import Param from '../modules/public_fun/param'

let quote_api_host = '//push2.eastmoney.com'

if(Param.get('env') == 'test'){
    quote_api_host = '//push2test.eastmoney.com'
}

declare var MobileSelect;
declare var Swiper;

let data = {
    newclass: null,
    timer:null,
    pz_size:10,
    quotaConfig: {
        host: '//push2.eastmoney.com',
        unpPath: '/api/qt/ulist.np/get',
        token: 'f057cbcbce2a86e2866ab8877db1d059',
        cPath: '/api/qt/clist/get',
        fs:[
            'm:0+t:6+f:!2,m:0+t:13+f:!2,m:0+t:80+f:!2,m:1+t:2+f:!2,m:1+t:23+f:!2,m:0+t:81+s:2048', // 沪深全市场
            // 'm:0+t:6+f:!2,m:0+t:13+f:!2,m:1+t:2+f:!2',// 沪深全市场，除科创板
            'm:0+t:6+f:!2,m:0+t:13+f:!2,m:0+t:80+f:!2,m:1+t:2+f:!2,m:1+t:23+f:!2', // 沪深A股
            'm:0+t:6,m:0+t:13,m:0+t:80,m:1+t:2', // 沪深主板
            'm:0+t:81+s:2048', // 京市主板
            'm:0+t:80', //创业板
            'm:1+t:23', //科创板
            'b:BK0815',// 昨日涨停
            'b:BK0501', // 次新股
            'b:BK0707,b:BK0804',//沪深股通
            'b:BK0596',// 融资融券
            'b:BK0611', // 上证50
            'b:BK0500', // 沪深300
            'b:BK0701', // 中证500
            'm:1+t:2+s:131072,m:1+t:23+s:131072,m:0+t:6+s:131072,m:0+t:80+s:131072', // 沪深注册制
            'm:1+t:2+s:524288,m:1+t:23+s:524288,m:0+t:6+s:524288,m:0+t:80+s:524288', // 沪深核准制
        ]
    },
    refresh_time: 10,
    fs_index:'m:0+t:6+f:!2,m:0+t:13+f:!2,m:0+t:80+f:!2,m:1+t:2+f:!2,m:1+t:23+f:!2,m:0+t:81+s:2048',
    // 初始化
    init: function () {
        let self = this
        self.getData(self.gethushenzhishu(), self.bindSwiperData)
        self.getData(quote_api_host + '/api/qt/ulist.np/get?secids=1.000001,0.399001&fields=f104,f105,f106&ut=6d2ffaa6a585d612eda28417681d58fb'+delayparams,self.bindStatistics)
        if (self.refresh_time > 0) {
            clearInterval(self.timer)
            self.timer = setInterval(() => {
                self.refresh()
            }, self.refresh_time * 1000);
        }
        self.table = self.makeQuoteTable()
        self.list1 = self.makeQuoteList1()
        self.list2 = self.makeQuoteList2()
        self.makeBK1()
        self.makeBK2()
        self.mobileSelectInit()
        $('.hsphb-more').on('click',async function(){
            try {
                let data = await self.table.showMore(20)
                self.pz_size +=20
                let dataNum = data.data.diff.length
                if(self.pz_size > dataNum){
                    $(".hsphb-more").html('已经到底了')
                }
            } catch (error) {
                $(".hsphb-more").html('暂无数据')
            }
        })
        // setTimeout(function(){
        //     self.bindFixed()
        // },1000)
    },
    // 沪深指数 Ajax 请求地址
    gethushenzhishu: function () {
        let self = this
        let ids = "1.000001,0.399001,0.399006,1.000300,0.399005";
        let url = self.quotaConfig.host + self.quotaConfig.unpPath
            + "?fltt=2&invt=2&fields=f1,f2,f3,f4,f12,f13,f14&secids=" + ids
            + "&ut=" + self.quotaConfig.token + "&forcect=1" + delayparams;
        return url
    },
    // Ajax 请求
    getData: function (url, callback) {
        let self = this
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                //-> data: 就是我们从服务器获取的数据，然后执行第四步的bindHTML方法
                callback(data,self)
            }
        })
    },
    // 给 Swiper 绑定数据
    bindSwiperData: function (data,self) {
        if (data.rc == 0) {
            let _class = ''
            let _siwper_html = ''
            data.data.diff.forEach((item, index) => {
                if (index == 0) {
                    _class = 'swiper-slide swiper-slide-active'
                } else if (index == 1) {
                    _class = 'swiper-slide swiper-slide-next'
                } else {
                    _class = 'swiper-slide'
                }
                _siwper_html += `<div class="${_class}">
                            <div class="zs-wrap">
                                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                                    <p>${item.f14}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                                        <span>${self.numberFix(item.f4,2)}</span>
                                        <span>${self.dataProcess(item.f3,'%')}</span>
                                    </p>
                                </a>
                            </div>
                        </div>`
            })
            $('#hushenzhishu').html(_siwper_html)
            let swiper = new Swiper('.hqq-swiper', {
                direction: 'horizontal',
                slidesPerGroup: 3,
                slidesPerView: 3,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.go-nuxt',
                    prevEl: '.go-pre',
                }
            })
        }
    },
    // 绑定涨跌统计
    bindStatistics:function(data){
        if(data.rc == 0){
            // 获取数据成功
            let _data = data.data.diff
            let _container = $(`.statistics-container`)
            let _asc = 0,_des = 0,_nor = 0;
            _data.forEach((item) => {
                _asc += item.f104;
                _des += item.f105;
                _nor += item.f106;
            })
            let _res = _asc+_des+_nor
            let _p = _container.find('p')
            _p[0].innerHTML = `涨${_asc}家`
            _p[1].innerHTML = `跌${_des}家`
            let _span = _container.find('span')
            _span[0].style.flex = `${_asc/_res}`
            _span[1].style.flex = `${_nor/_res}`
            _span[2].style.flex = `${_des/_res}`
        }
    },
    // Swiper 数据刷新
    refreshSwiperData: function (data,self) {
        let _dom = $('#hushenzhishu').find('.swiper-slide')
        if (data.rc == 0) {
            data.data.diff.forEach((item, index) => {
                _dom[index].innerHTML = `<div class="zs-wrap">
                <a href="/quote/stock/${item.f13}.${item.f12}.html">
                    <p>${item.f14}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>${self.numberFix(item.f2,2)}</p>
                    <p class='${item.f4 > 0 ? 'gp-asc' : (item.f4 < 0 ? 'gp-des' : '')}'>
                        <span>${self.numberFix(item.f4,2)}</span>
                        <span>${self.dataProcess(item.f3,'%')}</span>
                    </p>
                </a>
            </div>`
            })
        }
    },
    // 页面自刷
    refresh: function () {
        let self = this
        let url = self.gethushenzhishu()
        self.getData(url, self.refreshSwiperData)
        self.getData(quote_api_host + '/api/qt/ulist.np/get?secids=1.000001,0.399001&fields=f104,f105,f106&ut=6d2ffaa6a585d612eda28417681d58fb'+delayparams,self.bindStatistics)
    },
    // 
    bindFixed:function(){
        var banOffTop1=$("#title-fixed").offset().top;//获取到距离顶部的垂直距离
        var banOffHeight1 = $("#title-fixed").height()
        var h1 = $('.hqq-swiper').offset().top;
        var banOffTop2=$("#hsphb").offset().top;
        var scTop=0;//初始化垂直滚动的距离
        $(document).scroll(function(){
            scTop=$(this).scrollTop();//获取到滚动条拉动的距离
            if(scTop>=banOffTop1 - h1){
                $("#title-fixed").addClass("title-fix");
                $("#hsqsc-list").css("margin-top","4rem")
            }else{
                $("#title-fixed").removeClass("title-fix");
                $("#hsqsc-list").css("margin-top","0")
            }
            if(scTop>=banOffTop2 - h1 - banOffHeight1 - 10 && $("#hsphb").find('div')[0]){
                $("#hsphb").find('div')[0].classList.add('table-title-fix')
                $("#hsphb").children('div')[1].style.marginTop = '3rem'
            }else if(scTop<banOffTop2 - h1 - banOffHeight1 - 10 && $("#hsphb").find('div')[0]){
                $("#hsphb").find('div')[0].classList.remove('table-title-fix')
                $("#hsphb").children('div')[1].style.marginTop = '0'
            }
        })
    },
    makeQuoteTable: function () {
        let self = this
        let quotetable = new QuoteTable({
            ele: 'hsphb',
            api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fs=${self.fs_index}&fields=f1,f2,f3,f4,f5,f6,f7,f8,f9,f10,f12,f13,f14,f15,f16,f17,f18,f19,f20,f21,f23,f24,f25,f22,f11,f62,f111,f128,f136,f115,f148,f152${delayparams}`,
            params: { // 默认参数配置
                sortkey: 'f3',
                sortval: '1',
                size: '10'
            },
            right_tds: 3,
            refresh: 15,
            sortdesc:'1',
            sortasc:'0',
            item: [
                {
                    name: 'name',
                    title: '名称',
                    html: function (data) {
                        if (data == null) {
                            return `<th>${this.title}</th>`
                        } else {
                            let icon = ''
                            if ((data.f13 == 1) && (data.f19 == 23)) {
                                icon = icon + "<span class='icon-kc'>科创</span>"
                            }
                            if ((data.f13 == 0) && (data.f111 & 2048)){
                                icon = icon + "<span class='icon-kc'>京</span>"
                            }
                            if (data.f148 & 64) {
                                icon = icon + "<span class='icon-rz'>融</span>"
                            }
                            return `<td><p>${data.f14}</p><p>${data.f12}${icon}</p></td>`
                        }
                    },
                    sort: false
                },
                {
                    name: 'zx',
                    title: '最新',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th value="true" class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f3 > 0 ? 'shares-rise' : (data.f3<0?'shares-fall':'') }">${self.numberFix(data.f2,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f2'
                    }
                },
                {
                    name: 'zf',
                    title: '涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_des">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4 < 0?'shares-fall':'') }">${self.dataProcess(data.f3,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '0',
                        ascvalue: '1',
                        key: 'f3'
                    }
                },
                {
                    name: 'zd',
                    title: '涨跌',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f4 > 0 ? 'shares-rise' : (data.f4<0?'shares-fall':'') }">${self.numberFix(data.f4,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f4'
                    }
                },
                {
                    name: 'zs',
                    title: '涨速',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f22 > 0 ? 'shares-rise' : (data.f22<0?'shares-fall':'') }">${self.dataProcess(data.f22,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f22'
                    }
                },
                {
                    name: 'hs',
                    title: '换手',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dataProcess(data.f8,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f8'
                    }
                },
                {
                    name: 'zl',
                    title: '总量',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f5,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f5'
                    }
                },
                {
                    name: 'je',
                    title: '金额',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.conversion(data.f6,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f6'
                    }
                },
                {
                    name: 'lb',
                    title: '量比',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f10,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f10'
                    }
                },
                {
                    name: 'zg',
                    title: '最高',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f15 > data.f18 ? 'shares-rise' : (data.f15 < data.f18?'shares-fall':'') }">${self.numberFix(data.f15,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f15'
                    }
                },
                {
                    name: 'zd',
                    title: '最低',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f16 > data.f18 ? 'shares-rise' : (data.f16 < data.f18?'shares-fall':'') }">${self.numberFix(data.f16,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f16'
                    }
                },
                {
                    name: 'zf',
                    title: '振幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.dataProcess(data.f7,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f7'
                    }
                },{
                    name: 'jnzf',
                    title: '今年涨幅',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td class="${data.f25 > 0 ? 'shares-rise' : (data.f25<0?'shares-fall':'') }">${self.dataProcess(data.f25,'%')}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f25'
                    }
                },{
                    name: 'syl',
                    title: '市盈率',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f9,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f9'
                    }
                },{
                    name: 'sjl',
                    title: '市净率',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${self.numberFix(data.f23,2)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f23'
                    }
                },{
                    name: 'zsz',
                    title: '总市值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${ self.conversion(data.f20,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f20'
                    }
                },{
                    name: 'ltsz',
                    title: '流通市值',
                    html: function (data) {
                        if (data == null) {
                            // data为null的时候 ， 说明生成的为表头
                            return `<th class="sort_normal">${this.title}</th>`
                        } else {
                            return `<td>${ self.conversion(data.f21,true,true)}</td>`
                        }
                    },
                    sort: true,
                    sortitem: {
                        desvalue: '1',
                        ascvalue: '0',
                        key: 'f21'
                    }
                }
            ]
        })
        quotetable.init()
        return quotetable
    },
    makeQuoteList1: function () {
        let self = this
        let quoteList1 = new QuoteList({
            ele: 'hsqsc-list',
            tabconfig: {
                tabitem: [
                    {
                        name: 'zfb',
                        title: '涨幅榜',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&ut=7eea3edcaed734bea9cbfc24409ed989&pn=1&pz=10&po=1&np=1&fltt=2&invt=2&fid=f3&fs=${self.fs_index}&fields=f2,f3,f4,f12,f13,f14,f19,f111,f148${delayparams}`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ],
                        noData:function(data){
                            return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
                        }
                    },
                    {
                        name: 'dfb',
                        title: '跌幅榜',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=0&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=${self.fs_index}&fields=f2,f3,f4,f12,f13,f14,f19,f111,f148${delayparams}`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f3,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f3,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ],
                        noData:function(data){
                            return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
                        }
                    },
                    {
                        name: 'jlr',
                        title: '净流入',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f62&fs=${self.fs_index}&fields=f2,f3,f4,f12,f13,f14,f19,f111,f62,f148`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f62 > 0) {
                                        result = `<div class='shares-rise'>${ self.conversion(data.f62,true,true)}</div>`
                                    } else if (data.f62 < 0) {
                                        result = `<div class='shares-fall'>${ self.conversion(data.f62,true,true)}</div>`
                                    } else {
                                        result = `<div>${ self.conversion(data.f62,true,true)}</div>`
                                    }
                                    return result
                                }
                            }
                        ],
                        noData:function(data){
                            return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
                        }
                    },
                    {
                        name: 'hs;',
                        title: '换手率',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f8&fs=${self.fs_index}&fields=f2,f3,f4,f8,f12,f13,f14,f19,f111,f148`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = `<div>${self.dataProcess(data.f8,'%')}</div>`
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'lb;',
                        title: '量比',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f10&fs=${self.fs_index}&fields=f2,f3,f4,f8,f10,f12,f13,f14,f19,f111,f148`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = `<div>${self.numberFix(data.f10,2)}</div>`
                                    return result
                                }
                            }
                        ]
                    },
                    {
                        name: 'cje;',
                        title: '成交额',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f6&fs=${self.fs_index}&fields=f2,f3,f4,f6,f8,f10,f12,f13,f14,f19,f111,f148`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = `<div>${self.conversion(data.f6,true,true)}</div>`
                                    return result
                                }
                            }
                        ]
                    },

                ]
            },
            refresh: 15
        })

        quoteList1.init()

        return quoteList1
    },
    makeQuoteList2: function () {
        let self = this
        let quoteList2 = new QuoteList({
            ele: 'hsqsc-list1',
            tabconfig: {
                tabitem: [
                    {
                        name: 'zsb',
                        title: '涨速榜',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f22&fs=${self.fs_index}&fields=f2,f3,f4,f12,f13,f14,f19,f22,f111,f148${delayparams}`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f22 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f22,'%')}</div>`
                                    } else if (data.f22 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f22,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f22,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ],
                        noData:function(data){
                            return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
                        }
                    },
                    {
                        name: 'dsb',
                        title: '跌速榜',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=0&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f22&fs=${self.fs_index}&fields=f2,f3,f4,f12,f13,f14,f19,f111,f22,f148`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f22 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f22,'%')}</div>`
                                    } else if (data.f22 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f22,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f22,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ],
                        noData:function(data){
                            return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
                        }
                    },
                    {
                        name: 'pkyd',
                        title: '盘口异动', 
                        api: `${quote_api_host}/api/qt/pkyd/get?cb=?&ut=bd1d9ddb04089700cf9c27f6f7426281&lmt=9&fields=f1,f2,f3,f4,f5,f6,f7`,
                        dataprocess:true,
                        dataprocessData:function(data){
                            return data.data.pkyd
                        },
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let res = data.split(',')
                                    if(res[6] == 1){
                                        // 红色
                                        return `<div class='shares-rise' style='font-size:1.4rem;font-weight:normal;text-align:center;'>${res[0]}</div>`
                                    }else{
                                        // 绿色
                                        return `<div class='shares-fall' style='font-size:1.4rem;font-weight:normal;text-align:center;'>${res[0]}</div>`
                                    }
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let res = data.split(',')
                                    if(res[6] == 1){
                                        // 红色
                                        return `<div class='shares-rise' style='font-size:1.4rem;font-weight:normal;text-align:center;'>${res[3]}</div>`
                                    }else{
                                        // 绿色
                                        return `<div class='shares-fall' style='font-size:1.4rem;font-weight:normal;text-align:center;'>${res[3]}</div>`
                                    }
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let res = data.split(',')
                                    let o = {
                                        '1':'有大买盘',
                                        '101':'有大卖盘',
                                        '2':'大笔买入',
                                        '102':'大笔卖出',
                                        '201':'封涨停板',
                                        '301':'封跌停板',
                                        '202':'打开涨停',
                                        '302':'打开跌停',
                                        '203':'高开5日线',
                                        '303':'低开5日线',
                                        '204':'60日新高',
                                        '304':'60日新低',
                                        '401':'向上缺口',
                                        '501':'向下缺口',
                                        '402':'火箭发射',
                                        '502':'高台跳水',
                                        '403':'快速反弹',
                                        '503':'快速下跌',
                                        '404':'竞价上涨',
                                        '504':'竞价下跌',
                                        '405':'60日大幅上涨',
                                        '505':'60日大幅下跌'
                                    }
                                    if(res[6] == 1){
                                        // 红色
                                        return `<div class='shares-rise' style='font-size:1.4rem;font-weight:normal;text-align:center;'>${o[res[4]]}</div>`
                                    }else{
                                        // 绿色
                                        return `<div class='shares-fall' style='font-size:1.4rem;font-weight:normal;text-align:center;'>${o[res[4]]}</div>`
                                    }
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let res = data.split(',')
                                    if(res[6] == 1){
                                        // 红色
                                        return `<div class='shares-rise' style='font-size:1.4rem;font-weight:normal;text-align:center;'>${res[5]}</div>`
                                    }else{
                                        // 绿色
                                        return `<div class='shares-fall' style='font-size:1.4rem;font-weight:normal;text-align:center;'>${res[5]}</div>`
                                    }
                                }
                            }
                        ],
                        noData:function(data){
                            return "<div style='font-size:1.8rem;font-weight:600;text-align:center;padding-top:7rem;color:#686868;'>没有符合要求的个股</div>"
                        }
                    },
                    {
                        name: 'bkjs',
                        title: '板块涨速',
                        api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=10&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f22&fs=m:90&fields=f2,f3,f4,f6,f8,f10,f12,f13,f14,f19,f22,f111,f148`,
                        body: [
                            {
                                name: 'info',
                                html: function (data) {
                                    let icon = ''
                                    if ((data.f13 == 1) && (data.f19 == 23)) {
                                        icon = icon + "<span class='icon-kc'>科创</span>"
                                    }
                                    if ((data.f13 == 0) && (data.f111 & 2048)){
                                        icon = icon + "<span class='icon-kc'>京</span>"
                                    }
                                    if (data.f148 & 64) {
                                        icon = icon + "<span class='icon-rz'>融</span>"
                                    }
                                    return (`<div><p>${data.f14}</p><p>${data.f12}${icon}</p></div>`)
                                }
                            },
                            {
                                name: 'xj',
                                html: function (data) {
                                    let result = ''
                                    if (data.f4 > 0) {
                                        result = `<div class='shares-rise'>${self.numberFix(data.f2,2)}</div>`
                                    } else if (data.f4 < 0) {
                                        result = `<div class='shares-fall'>${self.numberFix(data.f2,2)}</div>`
                                    } else {
                                        result = `<div>${self.numberFix(data.f2,2)}</div>`
                                    }
                                    return result
                                }
                            },
                            {
                                name: 'zf',
                                html: function (data) {
                                    let result = ''
                                    if (data.f22 > 0) {
                                        result = `<div class='shares-rise'>${self.dataProcess(data.f22,'%')}</div>`
                                    } else if (data.f22 < 0) {
                                        result = `<div class='shares-fall'>${self.dataProcess(data.f22,'%')}</div>`
                                    } else {
                                        result = `<div>${self.dataProcess(data.f22,'%')}</div>`
                                    }
                                    return result
                                }
                            }
                        ]
                    }

                ]
            },
            refresh: 15
        })
        quoteList2.init()

        return quoteList2
    },
    makeBK1: function () {
        let bk1 = new TemplateBK({
            ele: 'hybk',
            api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=3&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=m:90+t:2+f:!50&fields=f3,f4,f12,f13,f14,f128,f136${delayparams}`,
            row: 1,
            col: 3,
            refresh_time:10,
            data: function (data) {
                return data.data.diff
            }
        })
        bk1.init()
    },
    makeBK2: function () {
        let bk2 = new TemplateBK({
            ele: 'gnbk',
            api: `${quote_api_host}/api/qt/clist/get?cb=?&pn=1&pz=3&po=1&np=1&ut=bd1d9ddb04089700cf9c27f6f7426281&fltt=2&invt=2&fid=f3&fs=m:90+t:3+f:!50&fields=f3,f4,f12,f13,f14,f128,f136${delayparams}`,
            row: 1,
            col: 3,
            refresh_time:10,
            data: function (data) {
                return data.data.diff
            }
        })
        bk2.init()
    },
    mobileSelectInit:function(){
        var self = this;
        var mobileSelect1 = new MobileSelect({
            trigger: '#trigger',// 点击容器的ID
            title: '单项选择',// 
            wheels: [
                { data: ['沪深京市场','沪深A股','沪深主板','京市主板','创业板','科创板','昨日涨停','次新股','沪深股通','融资融券','上证50','沪深300','中证500','注册制','核准制'] }
            ],
            position: [2], //Initialize positioning
            defaultselect:1, //起始位置 1
            callback: function (index,data) {
                // 修改排行榜是市场
                self.pz_size = 10
                $('.hsphb-more').html('查看更多<i class="arrow-down"></i>')
                self.fs_index = self.quotaConfig.fs[index-1]
                $("#market-title").html(data)
                // 取消旧市场定时刷新
                self.table.destroy()
                self.list1.destroy()
                self.list2.destroy()
                // 重新生成列表
                self.table = self.makeQuoteTable()
                self.list1 = self.makeQuoteList1()
                self.list2 = self.makeQuoteList2()
            }
        });
    },
    conversion(num: number, isSign: boolean, isUnit: boolean) {
        let numSign: string
        let self = this
        if (isSign) {
          if (num < 0) {
            numSign = '-'
          } else if (num == 0) {
            numSign = ''
          } else {
            numSign = ''
          }
        } else {
          numSign = ''
        }
        if (Math.abs(num) == 0) {
          return 0
        } else if (Math.abs(num) > 0 && Math.abs(num) < 1) {
          return numSign + self.numberFix(Math.abs(num), 3)
        } else if (Math.abs(num) >= 1 && Math.abs(num) < 100) {
          return numSign + self.numberFix(Math.abs(num), 2)
        } else if (Math.abs(num) >= 100 && Math.abs(num) < 1000) {
          return numSign + self.numberFix(Math.abs(num), 1)
        } else if (Math.abs(num) >= 1000 && Math.abs(num) < 10000) {
          return numSign + self.numberFix(Math.abs(num), 0)
        } else if (Math.abs(num) >= 10000 && Math.abs(num) < 1000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 2) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 2)
          }
        } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 1) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 1)
          }
        } else if (Math.abs(num) >= 10000000 && Math.abs(num) < 100000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 10000, 0) + '万'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 10000, 0)
          }
        } else if (Math.abs(num) >= 100000000 && Math.abs(num) < 10000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 2) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 2)
          }
        } else if (Math.abs(num) >= 10000000000 && Math.abs(num) < 100000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 1) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 1)
          }
        } else if (Math.abs(num) >= 100000000000 && Math.abs(num) < 1000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 0) + '亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 100000000, 0)
          }
        } else if (Math.abs(num) >= 1000000000000 && Math.abs(num) < 10000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1) + '万亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 1)
          }
        } else if (Math.abs(num) >= 10000000000000) {
          if (isUnit) {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0) + '万亿'
          } else {
            return numSign + self.numberFix(Math.abs(num) / 1000000000000, 0)
          }
        }else{
            return '-'
        }
    },
    numberFix(num: number, n: number) {
        var f = parseFloat(String(num));
        if (isNaN(f)) {
          return '-';
        }
        var f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
        if (n == 0) {
          return f
        } else {
          var s = f.toString();
          var rs = s.indexOf('.');
          if (rs < 0) {
            rs = s.length;
            s += '.';
          }
          while (s.length <= rs + n) {
            s += '0';
          }
          return s;
        }
    },
    dataProcess(data,symbol){
        let self = this
        if(data == undefined || data == null || data == '-'){
            return '-'
        }else{
            return self.numberFix(data,2) + symbol
        }
    }
}

data.init()



